import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".sbui-image-circle{border-radius:9999px}.sbui-image-rounded{border-radius:.25rem}.sbui-image-responsive{width:100%;height:auto}";
var ImageStyles = {"sbui-image":"sbui-image","sbui-image-circle":"sbui-image-circle","sbui-image-normal":"sbui-image-normal","sbui-image-rounded":"sbui-image-rounded","sbui-image-responsive":"sbui-image-responsive","sbuiImage":"sbui-image","sbuiImageCircle":"sbui-image-circle","sbuiImageNormal":"sbui-image-normal","sbuiImageRounded":"sbui-image-rounded","sbuiImageResponsive":"sbui-image-responsive"};
styleInject(css_248z);

export { ImageStyles as default };
